// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1931":"4b41cb55","2075":"4b41cb55","3409":"4b41cb55","5245":"4b41cb55","8243":"1e08f6e5","8246":"4b41cb55"}[chunkId] + ".chunk.css";
};